<template>
  <file-upload
    v-model="files"
    :extensions="extensions"
    :accept="accept"
    :name="name"
    :multiple="multiple"
    @input-filter="inputFilter"
    class="green-btn v-btn v-size--default text-white font-weight-bold"
    ref="upload"
  >
    <slot />
  </file-upload>
</template>

<script>
import FileUpload from "vue-upload-component";

export default {
  name: "BaseFileUpload",
  components: { FileUpload },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    name: String,
    extensions: String,
    accept: String,
    multiple: {
      type: Boolean,
      default: false,
    },
    inputFilter: Function,
  },
  data() {
    return {
      files: Array.isArray(this.modelValue) ? this.modelValue : [],
    };
  },
  watch: {
    files: {
      handler(val) {
        this.$emit("update:modelValue", val);
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        this.files = Array.isArray(val) ? val : [];
      },
      deep: true,
    },
  },
};
</script>
